import React from "react";

const Skeleton = ({ type = "rect", className = "", style = {} }) => {
  return (
    <div 
      className={`skeleton skeleton--${type} ${className}`} 
      style={style}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
